import { useState } from 'react';
import { Box, Button, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Nav from './nav';
import useResponsive from '../hooks/useResponsive';
import { useUserAuth } from '../context/auth_context';
import { Navigate } from 'react-router-dom';
import FirebaseAuth from '../firebase/auth';

export default function DefaultLayout({ children }) {
  const { user } = useUserAuth();

  const [open, setOpen] = useState(false);
  const isDesktop = useResponsive('up', 'lg');
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  if (user === 'loading') {
    return <div></div>;
  }
  if (!user) {
    return <Navigate to="/" />;
  }

  return (
    <Box display="flex">
      <Nav openNav={open} onCloseNav={() => setOpen(false)} />
      <Box gap={3} display="flex" flexDirection="column" width="100%" padding={{ xs: 2, md: 6 }}>
        <Box
          display="flex"
          justifyContent={isDesktop ? 'flex-end' : 'space-between'}
          alignItems="center">
          {!isDesktop && (
            <IconButton onClick={() => setOpen((prev) => !prev)}>
              <MenuIcon />
            </IconButton>
          )}
          <Box display="flex" gap={1} alignItems="center">
            <Typography variant="body1">Welcome Back!! </Typography>
            <Box>
              <Button style={{ textTransform: 'none' }} onClick={handleMenuClick}>
                Logout
              </Button>
              <Menu
                sx={{ width: '100%' }}
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleMenuClose}>
                {['Logout'].map((value) => (
                  <MenuItem
                    key={value}
                    onClick={() => {
                      FirebaseAuth.logOut();
                    }}>
                    {value}
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </Box>
        </Box>
        <Box>{children}</Box>
      </Box>
    </Box>
  );
}
